import React, { useEffect, useState, useCallback } from "react"
import API from "../../api/axios"
import AdminLayout from "./AdminLayout"

const AdminContacts = () => {
  const [contacts, setContacts]   = useState([])
  const [loading, setLoading]     = useState(true)
  const [error, setError]         = useState("")
  const [statusFilter, setFilter] = useState("")
  const [page, setPage]           = useState(1)
  const [pagination, setPagination] = useState({})
  const [expanded, setExpanded]   = useState(null)

  const fetchContacts = useCallback(async () => {
    setLoading(true)
    try {
      const params = new URLSearchParams({ page, limit: 20 })
      if (statusFilter) params.append("status", statusFilter)
      const { data } = await API.get(`/contact?${params}`)
      setContacts(data.data)
      setPagination(data.pagination || {})
    } catch { setError("Failed to load contacts.") }
    finally { setLoading(false) }
  }, [page, statusFilter])

  useEffect(() => { fetchContacts() }, [fetchContacts])

  const updateStatus = async (id, status) => {
    try {
      const { data } = await API.patch(`/contact/${id}/status`, { status })
      setContacts(prev => prev.map(c => c.id === id ? data.data : c))
    } catch { setError("Update failed.") }
  }

  const deleteContact = async (id) => {
    if (!window.confirm("Delete this message?")) return
    try {
      await API.delete(`/contact/${id}`)
      setContacts(prev => prev.filter(c => c.id !== id))
    } catch { setError("Delete failed.") }
  }

  const fmtDate = (d) => d ? new Date(d).toLocaleDateString("en-KE", { day: "numeric", month: "short", year: "numeric" }) : "-"

  return (
    <AdminLayout title="Contact Submissions">
      {error && <div className="admin-alert admin-alert-error">{error}</div>}

      <div className="admin-section">
        <div className="admin-section-header">
          <h3>Messages ({pagination.total || 0})</h3>
          <div className="admin-filters">
            <select className="admin-select" value={statusFilter} onChange={e => { setFilter(e.target.value); setPage(1) }}>
              <option value="">All Statuses</option>
              <option value="new">New</option>
              <option value="read">Read</option>
              <option value="replied">Replied</option>
            </select>
          </div>
        </div>

        <div className="admin-table-wrap">
          <table className="admin-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Subject</th>
                <th>Status</th>
                <th>Date</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {loading && (
                <tr className="admin-loading-row">
                  <td colSpan="6"><i className="fa fa-spinner fa-spin"></i> Loading…</td>
                </tr>
              )}
              {!loading && contacts.length === 0 && (
                <tr><td colSpan="6" className="admin-empty">No messages found.</td></tr>
              )}
              {!loading && contacts.map(c => (
                <React.Fragment key={c.id}>
                  <tr
                    style={{ cursor: "pointer" }}
                    onClick={() => setExpanded(expanded === c.id ? null : c.id)}
                  >
                    <td style={{ fontWeight: 600 }}>{c.name}</td>
                    <td>
                      <a href={`mailto:${c.email}`} style={{ color: "#c9a227" }} onClick={e => e.stopPropagation()}>
                        {c.email}
                      </a>
                    </td>
                    <td>{c.subject}</td>
                    <td onClick={e => e.stopPropagation()}>
                      <select
                        className="admin-select"
                        value={c.status}
                        onChange={e => updateStatus(c.id, e.target.value)}
                        style={{ padding: "3px 8px", fontSize: 12 }}
                      >
                        <option value="new">New</option>
                        <option value="read">Read</option>
                        <option value="replied">Replied</option>
                      </select>
                    </td>
                    <td style={{ fontSize: 12, color: "#888" }}>{fmtDate(c.createdAt)}</td>
                    <td onClick={e => e.stopPropagation()}>
                      <button
                        className="btn-sm btn-danger"
                        onClick={() => deleteContact(c.id)}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                  {expanded === c.id && (
                    <tr className="contact-message-row">
                      <td colSpan="6" className="contact-message-cell">
                        <strong>Phone:</strong> {c.phone || "—"}<br />
                        <strong>Message:</strong><br />
                        {c.message}
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>

        {pagination.pages > 1 && (
          <div style={{ display: "flex", justifyContent: "center", gap: 8, padding: "16px" }}>
            <button className="btn-sm btn-toggle" disabled={page <= 1} onClick={() => setPage(p => p - 1)}>← Prev</button>
            <span style={{ padding: "5px 12px", fontSize: 13, color: "#666" }}>Page {page} of {pagination.pages}</span>
            <button className="btn-sm btn-toggle" disabled={page >= pagination.pages} onClick={() => setPage(p => p + 1)}>Next →</button>
          </div>
        )}
      </div>
    </AdminLayout>
  )
}

export default AdminContacts
